import { roundOff, contains, getChartColor } from "utils/index";

const getBrokerIconByKey = (brokerKey, theme) => {
  let icon = "paper_surmount.png";

  if (brokerKey) {
    icon = brokerKey;
    if (theme === "light" && contains(brokerKey, "paper")) {
      icon += `_light`;
    }
    icon += `.svg`;
  }
  return `https://broker-icons-public.s3.amazonaws.com/${icon}`;
};

const getAverage = (numbers) => {
  if (numbers.length) {
    const avg = numbers.reduce((a, b) => a + b, 0) / numbers.length;
    return roundOff(Number(avg));
  } else {
    return 0;
  }
};

const mapPerformaceData = ({
  day = null,
  week = null,
  threeMonths = null,
  year = null,
}) => {
  let dayAvg = day;
  let weekAvg = week;
  let threeMonthsAvg = threeMonths;
  let yearAvg = year;

  if (dayAvg && dayAvg.profit_loss_pct) {
    dayAvg = getAverage(dayAvg.profit_loss_pct);
  }
  if (weekAvg && weekAvg.profit_loss_pct) {
    weekAvg = getAverage(weekAvg.profit_loss_pct);
  }
  if (threeMonthsAvg && threeMonthsAvg.profit_loss_pct) {
    threeMonthsAvg = getAverage(threeMonthsAvg.profit_loss_pct);
  }
  if (yearAvg && yearAvg.profit_loss_pct) {
    yearAvg = getAverage(yearAvg.profit_loss_pct);
  }

  dayAvg = Number.isInteger(dayAvg) ? roundOff(dayAvg) : dayAvg;
  weekAvg = Number.isInteger(weekAvg) ? roundOff(weekAvg) : weekAvg;
  threeMonthsAvg = Number.isInteger(threeMonthsAvg)
    ? roundOff(threeMonthsAvg)
    : threeMonthsAvg;
  yearAvg = Number.isInteger(yearAvg) ? roundOff(yearAvg) : yearAvg;

  return [
    {
      name: "Day",
      value: dayAvg,
      isProfit: dayAvg > 0,
    },
    {
      name: "Week",
      value: weekAvg,
      isProfit: weekAvg > 0,
    },
    {
      name: "3 Months",
      value: threeMonthsAvg,
      isProfit: threeMonthsAvg > 0,
    },
    {
      name: "Year",
      value: yearAvg,
      isProfit: yearAvg > 0,
    },
  ];
};

export const getConnectedPortfolios = (data) => {
  return data?.filter((d) => d.broker !== "paper");
};

export const getFilteredPortfolios = (data, theme) => {
  const _portfolios = [];

  for (let i = 0; i < data?.length; i++) {
    let d = data[i];
    const hp = d?.historical_performance;
    let prf = {};
    if (hp) {
      prf = {
        day: hp["1d"],
        week: hp["1w"],
        threeMonths: hp["3m"],
        year: hp["1y"],
      };
    }
    d = {
      id: d.id,
      brokerLogo: getBrokerIconByKey(d.broker, theme.mode),
      name: d.nickname || d.broker,
      created_at: d.created_at,
      performance: mapPerformaceData(prf),
      ...d,
    };
    _portfolios.push(d);
  }

  return _portfolios;
};

export const newAllocationPayload = (strategies, accountValue) => {
  let newAllocation = {
    new_allocation: {},
    update_flag: {},
  };
  for (let i = 0; i < strategies.length; i++) {
    const strategy = strategies[i];
    const dollars = Number(strategy.current_allocation.dollars.raw_number);
    const value = (dollars * 100) / accountValue;
    newAllocation.new_allocation[strategy.strategy_id] = value / 100;
    newAllocation.update_flag[strategy.strategy_id] = true;
  }
  return newAllocation;
};

export const updateAllocationStrategy = (
  { value, strategyIdx },
  strategies,
  accountValue
) => {
  const val = Number(value);
  const allStrategies = JSON.parse(JSON.stringify(strategies));
  const currentAllocation = allStrategies[strategyIdx].current_allocation;

  const percentage = (val / accountValue.raw_number) * 100;
  const parsePercentage = roundOff(percentage, 2);

  currentAllocation.dollars.raw_number = value || 0;
  currentAllocation.percent = percentage > 100 ? "--" : `${parsePercentage}%`;

  return allStrategies;
};

export const validateAllocationAmount = (investedAmount, maxAllocation) => {
  let hasError = true;
  let message = "";
  const parsedAmount = parseInt(investedAmount);

  if (Number.isNaN(investedAmount)) {
    message = "Please enter a valid number";
  } else if (parsedAmount < 100) {
    message = `Please enter a value ≥ $100.00`;
  } else if (parsedAmount > maxAllocation?.raw_number) {
    message = `Your total allocation cannot exceed ${maxAllocation.formatted}`;
  } else {
    message = "";
    hasError = false;
  }

  return { message, hasError };
};

export const prepareAllocationData = (data) => {
  const usedColors = [];

  return (
    data?.map((data) => {
      const color = getChartColor(usedColors);
      usedColors.push(color);
      return { ...data, color, fill: color };
    }) || []
  );
};

export const hPerformance = (historicalData) => {
  if (historicalData) {
    return historicalData?.map((value) => {
      return {
        name: value.datetime,
        $: value.value,
      };
    });
  }
};

export const getHPerformanceData = (chartData) => {
  if (!chartData || !Array.isArray(chartData)) {
    return [];
  }

  return chartData.map((item) => ({
    name: item.datetime || item.date,
    $: item.value,
    profit: item.profit,
    percentage: item.percentage,
  }));
};
